(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal-request-form"] && !Shopify.designMode) return;
  try {
    
  function updateWithdrawalProducts(field) {
    var checkboxes = field.querySelectorAll('[data-withdrawal-product-checkbox]');
    var hiddenInput = field.querySelector('[data-withdrawal-products-input]');
    var label = field.querySelector('[data-withdrawal-products-label]');
    var selectedProducts = field.querySelector('[data-withdrawal-selected-products]');
    var error = field.querySelector('[data-withdrawal-product-error]');
    var selected = [];

    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        selected.push(checkbox.value);
      }
    });

    hiddenInput.value = selected.join(', ');
    label.textContent = selected.length ? selected.length + ' producto(s) seleccionado(s)' : 'Selecciona uno o varios productos';
    error.textContent = selected.length ? '' : error.textContent;
    selectedProducts.innerHTML = '';

    selected.forEach(function (product) {
      var pill = document.createElement('span');
      pill.className = 'withdrawal-request__product-pill';
      pill.textContent = product;
      selectedProducts.appendChild(pill);
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-withdrawal-product-checkbox]')) {
      return;
    }

    var field = event.target.closest('[data-withdrawal-products]');
    updateWithdrawalProducts(field);
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-withdrawal-products-details][open]').forEach(function (details) {
      if (!details.closest('[data-withdrawal-products]').contains(event.target)) {
        details.open = false;
      }
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form.classList.contains('withdrawal-request__form')) {
      return;
    }

    var productField = form.querySelector('[data-withdrawal-products]');

    if (productField) {
      updateWithdrawalProducts(productField);

      var hiddenInput = productField.querySelector('[data-withdrawal-products-input]');
      var error = productField.querySelector('[data-withdrawal-product-error]');

      if (!hiddenInput.value) {
        event.preventDefault();
        error.textContent = 'Selecciona al menos un producto.';
        productField.querySelector('[data-withdrawal-products-details]').open = true;
        productField.querySelector('[data-withdrawal-products-details]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, true);

  } catch(e) { console.error(e); }
})();
})();
